import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Badge, Toast } from 'antd-mobile';
import { createUseStyles } from 'react-jss'
import {
    ExclamationOutlined,
    MoreOutlined
} from '@ant-design/icons';
import 'moment/locale/ru';

import { Action, CollectionServerMobile, errorCatch, GET, If, QueryOrder, QueryParam, useAuth, useUserContext } from 'fennec-ui'
import { DropdownMobile } from 'fennec-ui'
import { IFTrue } from '../../../../../../common/Rule'
import AdminSchool from '../../../../../forms/AdminSchool'
import AdminOrg from '../../../../../forms/AdminOrg'
import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../../../../objects/ZasedaniyaPravleniyaFederatsii/reducer'
import REDUX_Pari from '../../../../../../objects/Pari/reducer';
import { POST, IfElse } from 'fennec-ui'
import { BlockHeaderMobile } from 'fennec-ui';
import { ModelMobile } from 'fennec-ui';
import Collection from '../../../../../components/AbstractBuilder/Collection';
import './index.css'

import 'moment/locale/ru';
import { getChlenFederatsiiFromRoles, getKollektivFromRoles, getOrganizatorFromRoles, getParaFromRoles, getPrepodavatelFromRoles, getRregionalnoeOtdelenieFromRoles, getShkolaFromRoles, getSudyaFromRoles, getTantsorFromRoles, goTo } from '../../../../../../common/Tool';
import RegistratsiyaTantsoraShkoli from '../../../../../forms/RegistratsiyaTantsoraShkoli';
import { useTranslation } from 'react-i18next';

var _ = require('lodash');

const messageInfo = (info) => {
    Modal.show({
        content: info,
        closeOnMaskClick: true,
    })
};
const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    table: {
        marginLeft: "45px",
        '& .ant-table-tbody>tr>td': {
            borderBottom: "none"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px",
        color: "#9a9a9ab5",
        fontStyle: "italic",
        fontSize: "13px"
    }
})

function BtnTantsor(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Танцор федерации",
                subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                {
                    ...props,
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    titles: {
                        header: "Отменить регистрацию танцора в РО",
                        subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
                    },
                    document: "podatzayavlenienaotmenuregistratsiitantsorafederatsiivetomregot",
                    modify: (values) => {
                        return {
                            ...values,
                            tantsorID: object.ID
                        }
                    },
                    form: ModelMobile,
                    meta: [
                        {
                            label: "Причина",
                            name: "prichinaTekst",
                            type: "string",
                        },
                    ],
                },
            ]} />
    )
};
function BtnSudya(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Судья федерации",
                subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                {
                    ...props,
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    titles: {
                        header: "Отменить регистрацию судьи в РО",
                        subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
                    },
                    // form: PodatZayavlenieNaOtmenuRegistratsiiSudiFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiisudifederatsiivetomregot",
                    modify: (values) => {
                        return {
                            ...values,
                            sudyaID: object.ID
                        }
                    },
                    form: ModelMobile,
                    meta: [
                        {
                            label: "Причина",
                            name: "prichinaTekst",
                            type: "string",
                        },
                    ],
                },
            ]} />
    )
};
function BtnPrepodavatel(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Преподаватель федерации",
                subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                {
                    ...props,
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    titles: {
                        header: "Отменить регистрацию преподавателя в РО",
                        subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
                    },
                    // form: PodatZayavlenieNaOtmenuRegistratsiiPrepodavatelyaFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiiprepodavatelyafederatsiivetomregot",
                    modify: (values) => {
                        return {
                            ...values,
                            prepodavatelID: object.ID
                        }
                    },
                    form: ModelMobile,
                    meta: [
                        {
                            label: "Причина",
                            name: "prichinaTekst",
                            type: "string",
                        },
                    ],
                },
            ]} />
    )
};
function BtnOrganizator(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Организатор федерации",
                subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                {
                    ...props,
                    modal: { width: "700px" },
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    titles: {
                        header: "Отменить регистрацию организатора в РО",
                        subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
                    },
                    // form: PodatZayavlenieNaOtmenuRegistratsiiOrganizatoraFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiiorganizatorafederatsiivetomregot",
                    modify: (values) => {
                        return {
                            ...values,
                            organizatorID: object.ID
                        }
                    },
                    form: ModelMobile,
                    meta: [
                        {
                            label: "Причина",
                            name: "prichinaTekst",
                            type: "string",
                        },
                    ],
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    readonly: true,
                    titles: {
                        header: "Администраторы организатора",
                        subheader: (object && object.regionalnoeOtdelenie) ? object.regionalnoeOtdelenie.nazvanie : "",
                    },
                    form: AdminOrg,
                    document: ""
                },
            ]} />
    )
};
function BtnKollektiv(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Коллективы федерации",
                subheader: (object) ? object.nazvanie : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                {
                    ...props,
                    auth: auth,
                    object: props.object,
                    callback: props.callback,
                    titles: {
                        header: "Отменить регистрацию коллектива",
                        subheader: (object) ? object.nazvanie : "",
                    },
                    // form: PodatZayavlenieNaAnnulirovanieLitsenziiKollektivaFederatsii,
                    document: "podatzayavlenienaannulirovanielitsenziikollektivafederatsii",
                    modify: (values) => {
                        return {
                            ...values,
                            kollektivFederatsiiID: object.ID
                        }
                    },
                    form: ModelMobile,
                    meta: [
                        {
                            label: "Причина",
                            name: "prichinaTekst",
                            type: "string",
                        },
                    ],
                },
            ]} />
    )
};
function BtnShkola(props) {
    const auth = useAuth();
    const { object } = props;
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Школы федерации",
                subheader: (object) ? object.nazvanieShkoliTantsev : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                ...IfElse(!props?.object?.peremeshchenieShkoliVDrugoeROID &&
                    !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                    !props?.object?.zayavlenieOtVladeltsaShkoliNaVikhodID &&
                    !props?.object?.dokumentVikhodaIzFederatsiiID, [{
                        ...props,
                        auth,
                        object: props.object,
                        callback: props.callback,
                        titles: {
                            header: "Перемещение школы в другое отделение",
                            subheader: (object) ? object.nazvanieShkoliTantsev : "",
                        },
                        // form: PeremeshchenieShkoliVDrugoeRO,
                        document: "peremeshchenieshkolivdrugoero",
                        modify: (values) => {
                            return {
                                ...values,
                                shkolaID: object.ID
                            }
                        },
                        form: ModelMobile,
                        meta: [
                            {
                                label: "Новое региональное отделение",
                                name: "novoeRO",
                                type: "object",
                                relation: {
                                    displayFilter: () => "",
                                    displayTable: () => "",
                                    display: (item) => item.nazvanie,
                                    reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                    type: "many-one",
                                },
                                filter: "s-nazvanie"
                            },
                            {
                                label: "Коментарий",
                                name: "kommentarii",
                                type: "string",
                            },
                        ],
                    },
                    {
                        ...props,
                        auth,
                        object: props.object,
                        callback: props.callback,
                        titles: {
                            header: "Отменить регистрацию школы",
                            subheader: (object) ? object.nazvanieShkoliTantsev : "",
                        },
                        // form: PodatZayavlenieNaAnnulirovanieLitsenziiShkoliFederatsii,
                        document: "podatzayavlenienaannulirovanielitsenziishkolifederatsii",
                        modify: (values) => {
                            return {
                                ...values,
                                shkolaID: object.ID
                            }
                        },
                        form: ModelMobile,
                        meta: [
                            {
                                label: "Причина",
                                name: "prichinaTekst",
                                type: "string",
                            },
                        ],
                    }], []),
                {
                    ...props,
                    auth,
                    object: props.object,
                    callback: props.callback,
                    readonly: true,
                    titles: {
                        header: "Администраторы школы",
                        subheader: (object) ? object.nazvanieShkoliTantsev : "",
                    },
                    form: AdminSchool,
                    document: ""
                },
                {
                    ...props,
                    auth,
                    action: (values, unlock, close) => {
                        goTo(`/app/school/${props.object.ID}/settings`)
                    },
                    titles: {
                        header: "Настройки",
                    },
                },

            ]} />
    )
};
function BtnTantsorShkoli(props) {
    const auth = useAuth();
    const { object } = props;
    let ID = _.get(object, "_role.ID");
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Школы федерации",
                subheader: (object) ? <div>
                    <div>{object.nazvanieShkoliTantsev}</div>
                    {(!object?._role?.dokumentPodtverzhdeniyaID) ? <div style={{ fontSize: '12px', color: "orange" }}>Ожидает подтверждения школой!</div> : <></>}
                </div> : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [
                If((!props?.object?._role?.uchenikiShkolVtp?.[0]?.osnovnaya && props?.object?._role?.dokumentPodtverzhdeniyaID), {
                    title: "Сделать основной",
                    action: (values, unlock, close, { collection, setCollection }) => {
                        GET(auth, `/api/school/uchenikshkoli/osnovnaya/user/${ID}`,
                            () => {
                                // Придёт через сокет
                            }, errorCatch);
                    },
                }),
                {
                    title: "Удалить школу",
                    action: (values, unlock, close, { collection, setCollection }) => {
                        Modal.confirm({
                            title: 'Удаление школы',
                            content: 'Вы уверены что хотите удалить школу?',
                            confirmText: "Да",
                            cancelText: "Нет",
                            onConfirm: () => {
                                GET(auth, `/api/delete/school/uchenikshkoli/user/${ID}`,
                                    () => {
                                        // Придёт через сокет
                                    }, errorCatch);
                            },
                        })

                    },
                }]} />
    )
};
function BtnPrepodavatelShkoli(props) {
    const auth = useAuth();
    const { object } = props;
    let ID = _.get(object, "_role.ID");
    return (
        <DropdownMobile
            auth={auth}
            titles={{
                header: "Школы федерации",
                // subheader: (object) ? object.nazvanieShkoliTantsev : "",
                subheader: (object) ? <div>
                    <div>{object.nazvanieShkoliTantsev}</div>
                    {(!object?._role?.dokumentPodtverzhdeniyaID) ? <div style={{ fontSize: '12px', color: "orange" }}>Ожидает подтверждения школой!</div> : <></>}
                </div> : "",
            }}
            icon={<MoreOutlined />}
            buttonStyle={{ border: "none" }}
            items={() => [{
                title: "Удалить школу",
                action: (values, unlock, close, { collection, setCollection }) => {
                    GET(auth, `/api/delete/school/prepodavatel/user/${ID}`,
                        () => {
                            // Придёт через сокет
                        }, errorCatch);
                },
            }]} />
    )
};
function BtnPari(props) {
    const auth = useAuth();
    const { object } = props;
    const dispatch = useDispatch();
    const action = (values, unlock, close) => {
        POST(auth, "/api/polozhitelniiotvetnapredlozhenierukiiserdtsa", { paraID: object.ID },
            ({ data }) => {
                dispatch(REDUX_Pari.actions.updateArray([data]));
                close();
            },
            (err) => errorCatch(err, unlock));
    };
    if (!object.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
        return (
            <DropdownMobile
                auth={auth}
                titles={{
                    header: "Пары федерации",
                    subheader: (object) ? object.nazvanie : "",
                }}
                icon={<MoreOutlined />}
                buttonStyle={{ border: "none" }}
                items={() => [
                    {
                        ...props,
                        auth,
                        object: props.object,
                        titles: {
                            header: "Подтвердить создание пары",
                            subheader: (object) ? object.nazvanie : "",
                        },
                        action: action
                    },
                ]} />
        )
    } else {
        return (
            <DropdownMobile
                auth={auth}
                titles={{
                    header: "Пары федерации",
                    subheader: (object) ? object.nazvanie : "",
                }}
                icon={<MoreOutlined />}
                buttonStyle={{ border: "none" }}
                items={() => [
                    {
                        ...props,
                        auth,
                        object: props.object,
                        titles: {
                            header: "Добавить региональное отделение",
                            subheader: (object) ? object.nazvanie : "",
                        },
                        // form: SamostoyatelnayaRegistratsiyaPariFederatsii,
                        document: "samostoyatelnayaregistratsiyaparifederatsii",
                        modify: (values) => {
                            return {
                                ...values,
                                paraID: object.ID
                            }
                        },
                        form: ModelMobile,
                        meta: [
                            {
                                label: "Региональное отделение",
                                name: "regionalnoeOtdelenie",
                                type: "object",
                                relation: {
                                    displayFilter: () => "",
                                    displayTable: () => "",
                                    display: (item) => item.nazvanie,
                                    reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                    type: "many-one",
                                },
                                filter: "s-nazvanie"
                            },
                        ],
                    },
                    {
                        ...props,
                        auth,
                        object: props.object,
                        titles: {
                            header: "Выйти из пары",
                            subheader: (object) ? object.nazvanie : "",
                        },
                        // form: SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii,
                        document: "samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii",
                        form: ModelMobile,
                        meta: [
                            {
                                label: "Причина текст",
                                name: "prichinaTekst",
                                type: "string",
                            }
                        ],
                    },
                ]} />
        )
    }
};

function Title({ value }) {
    const classes = useStyles();
    return (
        <div className={classes.actionTitle}>
            {value}
        </div>
    );
}
export default function Currentregistrations(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();

    const { t } = useTranslation()

    const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения"], true));
    const chlenFederatsii = useSelector(getChlenFederatsiiFromRoles(["ЧленФедерации"]));
    const tantsor = useSelector(getTantsorFromRoles(["ТанцорФедерации"]));
    const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"]));
    const para = useSelector(getParaFromRoles(["АдминистраторПарыФедерации"])); // Пара
    const kollektiv = useSelector(getKollektivFromRoles(["АдминистраторКоллективаФедерации"])); // Коллектив
    const prepodavatel = useSelector(getPrepodavatelFromRoles(["ПреподавательФедерации"])); // Преподаватель
    const sudya = useSelector(getSudyaFromRoles(["СудьяФедерации"])); // Судья
    const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"])); // Организатор

    const tantsorShkoli = useSelector(getShkolaFromRoles(["УченикШколы"]));
    const prepodavatelShkoli = useSelector(getShkolaFromRoles(["ПреподавательШколы"]));

    const pari = useSelector(REDUX_Pari.selector.array);
    const zasedanie = useSelector(REDUX_ZasedaniyaPravleniyaFederatsii.selector.object, () => { });

    const columnsChlen = [
        {
            // title: 'X',
            render: (text, record) => {
                if (!record.dokumentVstupleniyaID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID)) {
                    if (!record.dokumentVstupleniyaID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ fontSize: '14px' }}>
                                Вступление в федерацию
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ fontSize: '14px' }}>
                                Исключение из федерации
                            </div>
                        );
                    }
                }
                return (<div style={{ fontSize: '14px' }}>
                    Вступил в федерацию
                </div>);
            },
        },
        {
            title: '',
            render: (text, record) => {
                if (!record.dokumentVstupleniyaID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID)) {
                    if (!record.dokumentVstupleniyaID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии члена федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении члена федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                }
                return (<></>);
            },
        },
    ];
    const columnsTantsor = [
        {
            title: 'Региональное отделение',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtTantsoraNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии танцора федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtTantsoraNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении танцора федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                }
                return (<BtnTantsor auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsSudya = [
        {
            title: 'Региональное отделение',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtSudiNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии судьи федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtSudiNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении судьи федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                }
                return (<BtnSudya auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPrepodavatel = [
        {
            title: 'Региональное отделение',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtPrepodavatelyaNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии преподавателя федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtPrepodavatelyaNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении преподавателя федерации")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                }
                return (<BtnPrepodavatel auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsOrganizator = [
        {
            title: 'Название',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.nazvanie}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtOrganizatoraNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии организатора федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtOrganizatoraNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении организатора федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                }
                return (<BtnOrganizator auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsShkola = [
        {
            title: 'Название',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieShkoliVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtVladeltsaShkoliNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии школы федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                    if ((record.peremeshchenieShkoliVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtVladeltsaShkoliNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                }
                return (<BtnShkola auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsTantsorShkoli = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: 'Основная',
            render: (text, record, index) => {
                return (
                    <span style={{ fontSize: '13px', fontStyle: 'italic', color: 'green' }}>{(record?._role?.uchenikiShkolVtp?.[0]?.osnovnaya) ? "Основная" : ""}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'w',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                if (!record?._role?.dokumentPodtverzhdeniyaID) {
                    return (
                        <span style={{ fontSize: '13px', color: "orange" }}>Ожидает подтверждения школой!</span>
                        // <div style={{ fontSize: '14px', textAlign: "center" }}>
                        //     <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает подтверждения школой федерации")}>
                        //         <ExclamationOutlined style={{ color: "orange" }} />
                        //     </div>
                        // </div>
                    );
                }
                return;
            },
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                return (<BtnTantsorShkoli auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPrepodavatelShkoli = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'w',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                if (!record?._role?.dokumentPodtverzhdeniyaID) {
                    return (
                        <span style={{ fontSize: '13px', color: "orange" }}>Ожидает подтверждения школой!</span>
                    );
                }
                return;
            },
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                return (<BtnPrepodavatelShkoli auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsKollektiv = [
        {
            title: 'Коллектив',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.nazvanieKollektiva}</span>
                );
            }
        },
        {
            title: 'Школа',
            render: (text, record) => {
                return (
                    <span style={{ fontSize: '14px' }}>{record.shkolaFederatsii.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFedDlyaRassmNaRasformKollektiva ||
                        record.zayavlenieOtVladeltsaShkoliNaRasformirovanieKollektiva)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о принятии коллектива федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                    if ((record.dokumentOtFedDlyaRassmNaRasformKollektiva ||
                        record.zayavlenieOtVladeltsaShkoliNaRasformirovanieKollektiva) && !record.dokumentRasformirovaniyaKollektiva) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает решения заседания регионального правления о исключении коллектива федерации")}>

                                <ExclamationOutlined style={{ color: "orange" }} />

                            </div>
                        );
                    }
                }
                return (<BtnKollektiv auth={auth} object={record} callback={() => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPari = [
        {
            title: 'Пара',
            render: (text, record) => {
                if (!record.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
                    return (
                        <>
                            {/* <Badge dot={true} offset={[5, 0]}> */}
                            <Badge status="error" />
                            <span style={{ fontSize: '14px' }}>{record.partner.lastname} {record.partner.firstname} - {record.partnersha.lastname} {record.partnersha.firstname}</span>
                            {/* </Badge> */}
                        </>
                    );
                } else {
                    return (
                        <>
                            <span style={{ fontSize: '14px' }}>{record.partner.lastname} {record.partner.firstname} - {record.partnersha.lastname} {record.partnersha.firstname}</span>
                        </>
                    );
                }
            }
        },
        {
            title: 'Рег. отделения',
            render: (text, record) => {
                const o = para.filter(i => i.paraID == record.ID).map(i => {

                    // if (!i.dokumentRegistratsiiID || (i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID || i.zayavlenieOtPartneraNaVikhodID)) {
                    if (!i.dokumentRegistratsiiID && i.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (<Action {...props} key={i.ID}
                            modal={{ width: "400px" }}
                            mode={"Tag"}
                            color="orange"
                            closable={false}
                            tooltip={"Ожидает решения заседания регионального правления о регистрации пары"}
                            auth={auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            // form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                            modify={(values) => {
                                return {
                                    ...values,
                                    paraID: i.ID
                                }
                            }}
                            form={ModelMobile}
                            meta={[
                                {
                                    label: "Причина",
                                    name: "prichinaTekst",
                                    type: "string",
                                },
                            ]}
                        />);
                    }
                    if (i.dokumentRegistratsiiID && (i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        i.zayavlenieOtPartneraNaVikhodID) && !i.dokumentVikhodaIzFederatsiiID) {
                        return (<Action {...props} key={i.ID}
                            modal={{ width: "400px" }}
                            mode={"Tag"}
                            color="orange"
                            closable={false}
                            tooltip={"Ожидает решения заседания регионального правления о выходе пары из регионального отделения"}
                            auth={auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            // form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                            modify={(values) => {
                                return {
                                    ...values,
                                    paraID: i.ID
                                }
                            }}
                            form={ModelMobile}
                            meta={[
                                {
                                    label: "Причина",
                                    name: "prichinaTekst",
                                    type: "string",
                                },
                            ]}
                        />);
                    }
                    // }
                    return (
                        <Action {...props} key={i.ID}
                            modal={{ width: "400px", title: "Отменить регистрацию пары в региональном отделении " + i.regionalnoeOtdelenie.nazvanie }}
                            mode={"Tag"}
                            closable={true}
                            auth={auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            // form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                            modify={(values) => {
                                return {
                                    ...values,
                                    paraID: i.ID
                                }
                            }}
                            form={ModelMobile}
                            meta={[
                                {
                                    label: "Причина",
                                    name: "prichinaTekst",
                                    type: "string",
                                },
                            ]}
                        />
                    );
                });
                return (o);
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                if (!record.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
                    if (record.dokPodachiZayavlNaRegistratsiyuOtInitsiatoraPari.creatorID == user.ID) {
                        return (
                            <div style={{ textAlign: "center" }} onClick={() => messageInfo("Ожидает подтверждения от партнера")}>
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </div>
                        );
                    }
                }
                return (<BtnPari auth={auth} object={record} callback={() => {
                }} />);
            },
        },
    ];
    const ctx = {
        chlenFederatsii,
        tantsor,
        shkola,
        para,
        kollektiv,
        prepodavatel,
        sudya,
        organizator,

        tantsorShkoli,
        prepodavatelShkoli,

        pari,
        zasedanie
    };
    return (
        <>
            <div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch" }}>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{t("currentregistrations.Танцор федерации")}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Танцор федерации",
                                    }}
                                    items={() => [
                                        IFTrue("samostoyatelnayaregistratsiyatantsorafederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Танцор Федерации",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaTantsoraFederatsii,
                                            document: "samostoyatelnayaregistratsiyatantsorafederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyatantsorafederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Танцор Федерации в еще одном РО",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaTantsoraFederatsii,
                                            document: "samostoyatelnayaregistratsiyatantsorafederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyatantsorafederatsii",
                                <Title value="Не являюсь Танцором Федерации" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyatantsorafederatsii",
                                <Collection data={tantsor} columns={columnsTantsor} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Судья федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Судья федерации",
                                    }}
                                    items={() => [
                                        IFTrue("samostoyatelnayaregistratsiyasudifederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Судья Федерации",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaSudiFederatsii,
                                            document: "samostoyatelnayaregistratsiyasudifederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyasudifederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Судья Федерации в еще одном РО",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaSudiFederatsii,
                                            document: "samostoyatelnayaregistratsiyasudifederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyasudifederatsii", {
                                            // ...props,
                                            auth: auth,
                                            titles: {
                                                header: "Судейская аттестация",
                                            },
                                            // title: "Судейская аттестация",
                                            action: (values, unlock, close) => {
                                                goTo(`/app/testing`)
                                            },
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyasudifederatsii",
                                <Title value="Не являюсь Судьей Федерации" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyasudifederatsii",
                                <Collection data={sudya} columns={columnsSudya} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Преподаватель федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Преподаватель федерации",
                                    }}
                                    items={() => [
                                        IFTrue("samostoyatelnayaregistratsiyaprepodavatelyafederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Преподаватель Федерации",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii,
                                            document: "samostoyatelnayaregistratsiyaprepodavatelyafederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyaprepodavatelyafederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Преподаватель Федерации в еще одном РО",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii,
                                            document: "samostoyatelnayaregistratsiyaprepodavatelyafederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyaprepodavatelyafederatsii",
                                <Title value="Не являюсь Преподавателем Федерации" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyaprepodavatelyafederatsii",
                                <Collection data={prepodavatel} columns={columnsPrepodavatel} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Организатор федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Организатор федерации",
                                    }}
                                    items={() => [
                                        IFTrue("samostoyatelnayaregistratsiyaorganizatora", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Организатор Федерации",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaOrganizatora,
                                            document: "samostoyatelnayaregistratsiyaorganizatora",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanie",
                                                    type: "string",
                                                },
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    // autoConduct: true,
                                                    // actions: {
                                                    //     uuid: "",
                                                    //     archive: null,
                                                    //     cancel: null,
                                                    //     create: null,
                                                    //     delete: null,
                                                    //     execute: null,
                                                    //     read: ["АдминистраторФедерации"],
                                                    //     update: null,
                                                    // },
                                                    // display: { uuid: "", name: "", sep: "", fields: null },
                                                    // view: {
                                                    //     disabled: null,
                                                    //     type: "",
                                                    //     unvisible: null,
                                                    //     unvisibleTable: null,
                                                    //     uuid: "",
                                                    // },
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyaorganizatora", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрироваться, как Организатор Федерации в еще одном РО",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaOrganizatora,
                                            document: "samostoyatelnayaregistratsiyaorganizatora",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanie",
                                                    type: "string",
                                                },
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyaorganizatora",
                                <Title value="Не являюсь Организатором Федерации" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyaorganizatora",
                                <Collection data={organizator} columns={columnsOrganizator} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Владелец школы федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Школы федерации",
                                    }}
                                    items={() => [
                                        IFTrue("samostoyatelnayaregistratsiyashkolifederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрировать танцевальную школу, владельцем которой я являюсь",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaShkoliFederatsii,
                                            document: "samostoyatelnayaregistratsiyashkolifederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanie",
                                                    type: "string",
                                                    validators: [
                                                        { required: true },
                                                        { max: 150, message: 'Значение должно быть не больше 150 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    duplex: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie",
                                                },
                                                {
                                                    label: "Город",
                                                    name: "gorod",
                                                    duplex: "gorod",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.name,
                                                        reference: { object: "City", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-name",
                                                    // filter: "s-name&w-regionID=@regionalnoeOtdelenie.regionID",
                                                    // queryFilter: [
                                                    //     QueryParam("w-region.ID", "@regionalnoeOtdelenie.region.ID")
                                                    // ]
                                                    dependence: { mode: "server", field: "region.ID", by: "regionalnoeOtdelenie", eq: "regionID" },
                                                },
                                                {
                                                    label: "Город строка",
                                                    name: "gorodStroka",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 100, message: 'Значение должно быть не больше 100 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Адрес",
                                                    name: "adres",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 500, message: 'Значение должно быть не больше 500 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Телефон",
                                                    name: "telefon",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 50, message: 'Значение должно быть не больше 50 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "E-mail",
                                                    name: "eMail",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 100, message: 'Значение должно быть не больше 100 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Сайт",
                                                    name: "sait",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 1024, message: 'Значение должно быть не больше 1024 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "VK",
                                                    name: "setVKontakte",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Instagram",
                                                    name: "setInstagram",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "TikTok",
                                                    name: "setTikTok",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Facebook",
                                                    name: "setFacebook",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("not-samostoyatelnayaregistratsiyashkolifederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрировать еще одну танцевальную школу, владельцем которой я являюсь",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaShkoliFederatsii,
                                            document: "samostoyatelnayaregistratsiyashkolifederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanie",
                                                    type: "string",
                                                    validators: [
                                                        { required: true },
                                                        { max: 150, message: 'Значение должно быть не больше 150 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    duplex: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie",
                                                },
                                                {
                                                    label: "Город",
                                                    name: "gorod",
                                                    duplex: "gorod",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.name,
                                                        reference: { object: "City", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-name",
                                                    // filter: "s-name&w-regionID=@regionalnoeOtdelenie.regionID",
                                                    // queryFilter: [
                                                    //     QueryParam("w-region.ID", "@regionalnoeOtdelenie.region.ID")
                                                    // ]
                                                    dependence: { mode: "server", field: "region.ID", by: "regionalnoeOtdelenie", eq: "regionID" },
                                                },
                                                {
                                                    label: "Город строка",
                                                    name: "gorodStroka",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 100, message: 'Значение должно быть не больше 100 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Адрес",
                                                    name: "adres",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 500, message: 'Значение должно быть не больше 500 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Телефон",
                                                    name: "telefon",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 50, message: 'Значение должно быть не больше 50 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "E-mail",
                                                    name: "eMail",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 100, message: 'Значение должно быть не больше 100 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Сайт",
                                                    name: "sait",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 1024, message: 'Значение должно быть не больше 1024 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "VK",
                                                    name: "setVKontakte",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Instagram",
                                                    name: "setInstagram",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "TikTok",
                                                    name: "setTikTok",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                                {
                                                    label: "Facebook",
                                                    name: "setFacebook",
                                                    type: "string",
                                                    validators: [
                                                        // { required: true },
                                                        { max: 250, message: 'Значение должно быть не больше 250 символов!' }
                                                    ],
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyashkolifederatsii",
                                <Title value="Не являюсь владельцем Танцевальной Школы" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyashkolifederatsii",
                                <Collection data={shkola} columns={columnsShkola} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Занимаюсь в школах"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Занимаюсь в школах",
                                    }}
                                    items={() => [{
                                        ...props,
                                        auth,
                                        mode: "MenuItem",
                                        titles: {
                                            header: "Добавить танцевальную школу, в которой я занимаюсь",
                                        },
                                        form: RegistratsiyaTantsoraShkoli,
                                        action: (values, unlock, close) => {
                                            GET(auth, `/api/podatzayavlenienaregistratsiuuchenikaschool/${values.shkolaID}`,
                                                ({ data }) => {
                                                    // console.log(data);
                                                    close();
                                                }, (err) => errorCatch(err, () => unlock()));
                                        },
                                    }]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {(tantsorShkoli && tantsorShkoli.length <= 0) &&
                                <Title value="Не занимаюсь в танцевальнх школах" />
                            }
                            {(tantsorShkoli && tantsorShkoli.length > 0) &&
                                <Collection data={tantsorShkoli} columns={columnsTantsorShkoli} />
                            }
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Преподаватель школы"}</div>
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {(prepodavatelShkoli && prepodavatelShkoli.length <= 0) &&
                                <Title value="Не являюсь преподавателем в танцевальнх школ" />
                            }
                            {(prepodavatelShkoli && prepodavatelShkoli.length > 0) &&
                                <Collection data={prepodavatelShkoli} columns={columnsPrepodavatelShkoli} />
                            }
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Коллективы федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Коллективы федерации",
                                    }}
                                    items={() => [
                                        {
                                            ...props,
                                            titles: {
                                                header: "Зарегистрировать коллектив",
                                            },
                                            // form: SamostoyatelnayaRegistratsiyaKollektivaFederatsii,
                                            document: "samostoyatelnayaregistratsiyakollektivafederatsii",
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanieKollektiva",
                                                    type: "string",
                                                },
                                                {
                                                    label: "Школа",
                                                    name: "shkolaFederatsii",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanieShkoliTantsev,
                                                        reference: {
                                                            // object: "RegionalnieOtdeleniya", 
                                                            data: shkola,
                                                            property: "ID"
                                                        },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanieShkoliTantsev"
                                                },
                                            ],
                                        },
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("samostoyatelnayaregistratsiyakollektivafederatsii",
                                <Title value="Нет коллективов" />
                                , undefined, ctx)}
                            {IFTrue("not-samostoyatelnayaregistratsiyakollektivafederatsii",
                                <Collection data={kollektiv} columns={columnsKollektiv} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Пары федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Пары федерации",
                                    }}
                                    items={() => [
                                        {
                                            ...props,
                                            // callback: (res) => {
                                            //     dispatch(REDUX_Pari.actions.updateArray([res.data]));
                                            // },
                                            titles: {
                                                header: "Зарегистрировать пару",
                                            },
                                            action: (values, unlock, close) => {
                                                POST(auth, "/api/predlozhenierukiiserdtsa", {
                                                    ...values,
                                                    partnerID: values?.partner?.ID,
                                                    partnershaID: values?.partnersha?.ID
                                                },
                                                    ({ data }) => {
                                                        dispatch(REDUX_Pari.actions.updateArray([data]));
                                                        close();
                                                    },
                                                    (err) => {
                                                        unlock();
                                                        Toast.show({
                                                            content: err.message || err.exception,
                                                            icon: "fail",
                                                            position: "top"
                                                        });
                                                    });
                                            },
                                            // document: "predlozhenierukiiserdtsa",
                                            // form: PredlozhenieRukiISerdtsa,
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                IfElse(
                                                    [user.genderID === 1],
                                                    {
                                                        label: "Партнерша",
                                                        name: "partnersha",
                                                        duplex: "partnersha",
                                                        type: "action",
                                                        display: (v) => {
                                                            return v.firstname + " " + v.lastname
                                                        },
                                                        modify: (values) => {
                                                            //вернуть ID партнера из объекта с соответствующего шага
                                                            return values.search;
                                                        },
                                                        modifyDuplex: (values) => {
                                                            //вернуть ID партнера из объекта с соответствующего шага
                                                            return values.search;
                                                        },
                                                        steps: [
                                                            {
                                                                key: "search",
                                                                name: "Шаг 1",
                                                                action: (values, unlock, close) => {
                                                                    POST(auth, "/api/find/tantsorifederatsiifilter", { ...values, Gender: 2 },
                                                                        ({ data }) => {
                                                                            close(data);
                                                                        },
                                                                        (err) => {
                                                                            unlock();
                                                                            Toast.show({
                                                                                content: err.message || err.exception,
                                                                                icon: "fail",
                                                                                position: "top"
                                                                            });
                                                                        });
                                                                },
                                                                form: ModelMobile,
                                                                meta: [
                                                                    // {
                                                                    //     label: "Телефон",
                                                                    //     name: "Phone",
                                                                    //     type: "string",
                                                                    //     display: (v) => v,
                                                                    // },
                                                                    {
                                                                        label: "Email",
                                                                        name: "Email",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    {
                                                                        label: "Фамилия",
                                                                        name: "Lastname",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    {
                                                                        label: "Имя",
                                                                        name: "Firstname",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    // {
                                                                    //     label: "Дата рождения",
                                                                    //     name: "Birthday",
                                                                    //     type: "date",
                                                                    //     display: (v) => v,
                                                                    // },
                                                                ],
                                                            },
                                                            {
                                                                key: "select",
                                                                name: "Шаг 2",
                                                                noAntForm: true,
                                                                form: (props) => {
                                                                    return (
                                                                        <div>
                                                                            <div>Подтвердите выбор партнерши:</div>
                                                                            <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                                                            {/* <div>Телефон: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.phone : ""}</span></div> */}
                                                                            <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                                                            {/* <div>Дата рождения: <span style={{ color: "#000" }}>{(props.data) ? moment(props.data.search.birthday).format("YYYY-MM-DD") : ""}</span></div> */}
                                                                        </div>
                                                                    )
                                                                },
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        label: "Партнер",
                                                        name: "partner",
                                                        duplex: "partner",
                                                        type: "action",
                                                        display: (v) => {
                                                            return v.firstname + " " + v.lastname
                                                        },
                                                        modify: (values) => {
                                                            //вернуть ID партнера из объекта с соответствующего шага
                                                            return values.search;
                                                        },
                                                        modifyDuplex: (values) => {
                                                            //вернуть ID партнера из объекта с соответствующего шага
                                                            return values.search;
                                                        },
                                                        steps: [
                                                            {
                                                                key: "search",
                                                                name: "Шаг 1",
                                                                action: (values, unlock, close) => {
                                                                    POST(auth, "/api/find/tantsorifederatsiifilter", { ...values, Gender: 1 },
                                                                        ({ data }) => {
                                                                            close(data);
                                                                        },
                                                                        (err) => {
                                                                            unlock();
                                                                            Toast.show({
                                                                                content: err.message || err.exception,
                                                                                icon: "fail",
                                                                                position: "top"
                                                                            });
                                                                        });
                                                                },
                                                                form: ModelMobile,
                                                                meta: [
                                                                    // {
                                                                    //     label: "Телефон",
                                                                    //     name: "Phone",
                                                                    //     type: "string",
                                                                    //     display: (v) => v,
                                                                    // },
                                                                    {
                                                                        label: "Email",
                                                                        name: "Email",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    {
                                                                        label: "Фамилия",
                                                                        name: "Lastname",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    {
                                                                        label: "Имя",
                                                                        name: "Firstname",
                                                                        type: "string",
                                                                        display: (v) => v,
                                                                    },
                                                                    // {
                                                                    //     label: "Дата рождения",
                                                                    //     name: "Birthday",
                                                                    //     type: "date",
                                                                    //     display: (v) => v,
                                                                    // },
                                                                ],
                                                            },
                                                            {
                                                                key: "select",
                                                                name: "Шаг 2",
                                                                noAntForm: true,
                                                                form: (props) => {
                                                                    return (
                                                                        <div>
                                                                            <div>Подтвердите выбор партнера:</div>
                                                                            <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                                                            {/* <div>Телефон: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.phone : ""}</span></div> */}
                                                                            <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                                                            {/* <div>Дата рождения: <span style={{ color: "#000" }}>{(props.data) ? moment(props.data.search.birthday).format("YYYY-MM-DD") : ""}</span></div> */}
                                                                        </div>
                                                                    )
                                                                },
                                                            }
                                                        ]
                                                    }
                                                ),
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: {
                                                            object: "RegionalnieOtdeleniya",
                                                            // data: shkola,
                                                            property: "ID"
                                                        },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie",
                                                    queryFilter: [
                                                        QueryOrder("nazvanie", "ASC")
                                                    ]
                                                },
                                                {
                                                    label: "Сценическое название пары",
                                                    name: "stsenicheskoeNazvaniePari",
                                                    type: "string",
                                                },
                                            ],
                                        },
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("predlozhenierukiiserdtsa",
                                <Title value="Нет пары" />
                                , undefined, ctx)}
                            {IFTrue("pari",
                                <Collection data={pari} columns={columnsPari} />
                                , undefined, ctx)}
                        </div>
                    </div>
                    <div>
                        <div style={{ padding: "5px 0px" }}>
                            <div className='bg bg-grey' style={{
                                textAlign: "left",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "rgb(0, 0, 0)"
                                }}>{"Член федерации"}</div>
                                <DropdownMobile
                                    auth={auth}
                                    titles={{
                                        header: "Член федерации",
                                    }}
                                    items={() => [
                                        IFTrue("zayavlenienachlenstvovfederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Стать членом Федерации",
                                            },
                                            document: "zayavlenienachlenstvovfederatsii",
                                            // form: ZayavlenieNaChlenstvoVFederatsii,
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Описание желания стать членом федерации",
                                                    name: "opisanieZhelaniyaStatChlenomFederatsii",
                                                    type: "string",
                                                },
                                                {
                                                    label: "Региональное отделение",
                                                    name: "regionalnoeOtdelenie",
                                                    type: "object",
                                                    relation: {
                                                        displayFilter: () => "",
                                                        displayTable: () => "",
                                                        display: (item) => item.nazvanie,
                                                        reference: { object: "RegionalnieOtdeleniya", property: "ID" },
                                                        type: "many-one",
                                                    },
                                                    filter: "s-nazvanie"
                                                },
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                        IFTrue("samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii", {
                                            ...props,
                                            titles: {
                                                header: "Выйти из Федерации",
                                            },
                                            document: "samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii",
                                            // form: SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii,
                                            form: ModelMobile,
                                            auth: auth,
                                            meta: [
                                                {
                                                    label: "Причина текст",
                                                    name: "prichinaTekst",
                                                    type: "string",
                                                }
                                            ],
                                        }, undefined, {
                                            chlenFederatsii,
                                            tantsor,
                                            shkola,
                                            para,
                                            kollektiv,
                                            prepodavatel,
                                            sudya,
                                            organizator,
                                            pari,
                                            zasedanie
                                        }),
                                    ]} />
                            </div>
                        </div>
                        <div style={{ padding: "0 5px" }}>
                            {IFTrue("zayavlenienachlenstvovfederatsii",
                                <Title value="Не являюсь Членом Федерации" />
                                , undefined, ctx)}
                            {IFTrue("not-zayavlenienachlenstvovfederatsii",
                                <Collection data={chlenFederatsii} columns={columnsChlen} />
                                , undefined, ctx)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
